import {Link} from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import {AES, enc} from "crypto-js";
import {Suspense, useEffect, useState} from "react";
import ApiRequester from "./ApiRequester";
import {toast, ToastContainer} from "react-toastify";
import {Modal} from 'bootstrap';
import {CSVLink} from "react-csv";
import Header from "./Header";
import Button from "./component-assets/Button";
import {
    paginateData, sortFunc, formFail, handleSubmitActions, actionAppearance, deleteModalSingle,
    bulkDeleteModal, checkAll, formCheck, formSuccess, showModal, iAmHigherAuthority, isBannerPresent, arrayComparison,
    headerFilterFunc, searchFunc
} from "../libs";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems";
import Footer from "./Footer";
import TableBody from "./component-assets/TableBody";
import TableHeaders from "./component-assets/TableHeaders";
import BulkDeleteModal from "./component-assets/BulkDeleteModal";
import SingleDeleteModal from "./component-assets/SingleDeleteModal";
import PerPageModal from "./component-assets/PerPageModal";
import CampusDropDown from "./component-assets/CampusDropDown";
import Navigation from "./Navigation";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton";

const ResidentGroups = (props) => {
    let dData, bData, headerData, csvHeaders, headerData2;

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    headerData = [
        {label: "Group", key: "resident_group_name", align: "center", filtered: true},
        {label: "Description", key: "resident_description", align: "left", filtered: true},
        {label: "Residents", key: "resident_name", align: "left", filtered: true, type: "ellipsis"},
    ];

    csvHeaders = [
        {label: "Group", key: "resident_group_name"},
        {label: "Description", key: "resident_description"},
        {label: "Residents", key: "resident_name"}
    ];

    if (iAmHigherAuthority(99, dData?.role_weight)){
        csvHeaders.splice(0, 0, {label: "Group ID", key: "resident_group_id"});
    }

    const [resLinkClose, setResLinkClose] = useState("cancelEditBtn");

    headerData2 = [
        {label: "Name", key: "resident_name", align: "left", filtered: false,
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id",
                inmodal: true, modalKey: resLinkClose}},
        {label: "Area", key: "area_name", align: "center", filtered: false,
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id",
                inmodal: true, modalKey: resLinkClose}},
        {label: "Area Type", key: "area_type_description", align: "center", filtered: false}
    ];

    // Permission Variables
    const [addRights, setAddRights] = useState(iAmHigherAuthority(10, dData?.role_weight));
    const [editRights, setEditRights] = useState(iAmHigherAuthority(10, dData?.role_weight));
    const [deleteRights, setDeleteRights] = useState(iAmHigherAuthority(10, dData?.role_weight));
    const [read, setRead] = useState(true);
    const [resLoaded, setResLoaded] = useState(false);
    const [catLoaded, setCatLoaded] = useState(false);
    const [originLoaded, setOriginLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />);
    // Main Table Variables
    const [dataOrigin, setDataOrigin] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [loadState, setLoadState] = useState("groups");
    const [count, setCount] = useState(0);
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [resGroupIdList, setResGroupIdList] = useState([]);
    const [search, setSearch] = useState("");
    const [campusId, setCampusId] = useState(dData.acnt);
    const [headerFilters, setHeaderFilters] = useState([]);
    const [headerResFilters, setHeaderResFilters] = useState([]);
    const [sorter, setSorter] = useState({
        sortColumn: "resident_group_name",
        sortOrder: "asc"
    });
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    // Resident Picker Table Variables
    const [resData, setResData] = useState([]);
    const [resIdList, setResIdList] = useState([]);
    const [oldResIdList, setOldResIdList] = useState([]);
    const [resDataCnt, setResDataCnt] = useState(0);
    const [resTableRows, setResTableRows] = useState([]);
    const [storedIndex, setStoredIndex] = useState(0);
    const [search2, setSearch2] = useState("");
    const [sorter2, setSorter2] = useState({
        sortColumn: "resident_name",
        sortOrder: "asc"
    });
    // Group Category Variables
    const [groupCategoryData, setGroupCategoryData] = useState([]);
    const [groupCatDd, setGroupCatDd] = useState([]);
    const [groupCatSorter, setGroupCatSorter] = useState({
        sortColumn: "resident_group_category_name",
        sortOrder: "asc"
    })
    // Other Enact Once Variables
    const [csvLink, setLink] = useState({
        filename: "ResidentGroups.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"}
                    class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                procedure: "sp_dev_getresidentsbycampusid", reqType: "stored"}).then(data => {
                setResData(data ? data : []);
                setResLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                Tbl: "att_resident_group_category", "read-only": true,
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setGroupCategoryData(data ? data : []);
                setCatLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": read,
                                payload: {campus_id: campusId, category_filter: "", entity_type_filter: "",
                                            entity_filter: ""},
                                procedure: "sp_dev_getresidentgroupandresidentbycampusid", reqType: "stored"}).then(data => {
                setDataOrigin(data ? data : []);
                setOriginLoaded(true);
            });
            setRead(true);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let pRules = paginateData(activeData, page, perPage);
        setPRules(pRules);
        if (activeData?.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={deleteRights}
                                writeAccess={editRights} unk={"a-"}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBtn"])}
                                tableHeaders={headerData} editModal={editModal} parentComponent={"Groups"} dData={dData}
                                modal={editRights && resLoaded && catLoaded} checkboxlist={resGroupIdList}
                                setCheckboxId={(value) => {setResGroupIdList(value)}}
                                checkidkey={"resident_group_id"} />);
    }, [activeData, sorter, page, perPage, resGroupIdList, resData, resLoaded, catLoaded]);

    useEffect(() => {
        setLink(prevState => {
            return {...prevState,
                headers: csvHeaders,
                data: dataOrigin}
        });
    }, [dataOrigin]);

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        );
    }, [csvLink]);

    useEffect(() => {
        if (![originLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [originLoaded]);

    useEffect(() => {
        if (groupCategoryData.length > 0){
            let tmpOptions = [];
            groupCategoryData.sort((a, b) => sortFunc(a, b, groupCatSorter.sortColumn, groupCatSorter.sortOrder));
            for (let i=0; i<groupCategoryData.length; i++){
                tmpOptions.push(
                    <option key={"area-type-option-"+groupCategoryData[i].resident_group_category_id.toString()}
                            value={groupCategoryData[i].resident_group_category_id}>{groupCategoryData[i].resident_group_category_name}</option>
                );
            }
            setGroupCatDd(() => tmpOptions);
        }
    }, [groupCategoryData]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(dataOrigin, headerFilters, headerData);

        searchKeys = ["resident_group_name", "resident_description", "resident_name"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setActiveData(tmpData);
    }, [search, dataOrigin, headerFilters]);

    useEffect(() => {
        let tmpData, searchKeys;

        let filteredData = headerFilterFunc(resData, headerResFilters, headerData2);

        searchKeys = ["resident_name", "area_name", "area_type_description", "area_type_name"];
        tmpData = searchFunc(search2, filteredData, searchKeys);

        setResDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, sorter2.sortColumn, sorter2.sortOrder));
        setResTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={editRights}
                                     actionAppearance={() => {}} tableHeaders={headerData2} checkboxId={"uCheckGroup"}
                                     parentComponent={"Residents"} dData={dData} checkboxlist={resIdList}
                                     modal={false} editModal={() => {}} unk={"a-"}
                                     setCheckboxId={(value) => {setResIdList(value)}} checkidkey={"resident_id"} />);
    }, [resData, resIdList, sorter2, search2, activeData, headerResFilters]);

    function editModal(groupIndex){
        let groupId, groupname, dataIndex, modal, delBtn, rIdList = [];
        if (editRights){
            dataIndex = parseInt(groupIndex);
            setSearch2("");
            setHeaderResFilters([]);
            setStoredIndex(dataIndex);
            setResLinkClose("cancelEditBtn");
            document.getElementById("lastIndex").value = dataIndex;
            groupname = document.getElementById("groupNameE");
            groupId = document.getElementById("groupIdE");
            delBtn = document.getElementById("deleteSingleBtn");
            document.getElementById("categoryE").value = activeData[dataIndex]?.resident_group_category_id;
            document.getElementById("descriptionE").value = activeData[dataIndex]?.resident_description;
            document.getElementById("uCheckHead2").checked = false;
            for (let i2=0; i2<activeData[dataIndex]?.residents?.length; i2++){
                if (!rIdList.includes(activeData[dataIndex]?.residents[i2]?.resident_id.toString())){
                    rIdList.push(activeData[dataIndex]?.residents[i2]?.resident_id.toString());
                }
            }
            setResIdList(rIdList);
            setOldResIdList(rIdList);
            document.getElementById("uCheckHead2").checked = rIdList && rIdList.length === resData.length;
            groupname.value = activeData[dataIndex]?.resident_group_name;
            groupId.value = activeData[dataIndex]?.resident_group_id;
            delBtn.onclick = () => {
                setDContent([[groupId.value, ""]]);
                deleteModalSingle(groupname.value, groupname.value);
            };
            formCheck("editForm", "editSubmit");
            modal = new Modal(document.getElementById("editmodal"), {});
            modal.show();
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function filterSubmit(){
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        setResGroupIdList([]);
        dData.perPage = tmpPerPage;
        setPage(1);
        ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), process.env.REACT_APP_ESECRET).toString());
        formSuccess("Page parameters stored to session.", "filterSubmit", "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    function formAddSubmit(){
        // User add form submit function
        let groupname, payload, description, categoryId;
        if (addRights){
            handleSubmitActions("addSubmit", "loadAddSubmit");
            groupname = document.getElementById("groupname").value;
            description = document.getElementById("description").value;
            categoryId = document.getElementById("category").value;
            payload = [{campus_id: campusId, resident_group_name: groupname, resident_description: description,
                        resident_ids: resIdList, resident_group_category_id: parseInt(categoryId)}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_group_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setRead(false);
                    setResGroupIdList([]);
                    formSuccess("Group has been added.", "addSubmit", "loadAddSubmit", "cancelAddBtn", "addForm");
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addSubmit", "loadAddSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function formEditSubmit(){
        // User add form submit function
        let groupId, groupname, description, payload, categoryId, oldCategoryId, oldDescription, oldGroupName,
            oldPayload;
        if (editRights){
            groupId = document.getElementById("groupIdE").value;
            groupname = document.getElementById("groupNameE").value;
            description = document.getElementById("descriptionE").value;
            categoryId = document.getElementById("categoryE").value;
            oldGroupName = activeData[storedIndex]?.resident_group_name;
            oldCategoryId = activeData[storedIndex]?.resident_group_category_id;
            oldDescription = activeData[storedIndex]?.resident_description;
            if (arrayComparison([groupname, description, categoryId], [oldGroupName, oldDescription, oldCategoryId])
                || arrayComparison(resIdList, oldResIdList)){
                handleSubmitActions("editSubmit", "loadEditSubmit");
                payload = [{resident_group_name: groupname, resident_group_id: parseInt(groupId), resident_group_category_id: parseInt(categoryId),
                        resident_description: description, resident_ids: resIdList, campus_id: dData.acnt}];
                oldPayload = [{resident_group_name: oldGroupName, resident_group_id: parseInt(groupId),
                               resident_group_category_id: oldCategoryId, resident_description: oldDescription,
                               resident_ids: oldResIdList, campus_id: dData.acnt}];
                ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_group_edit", Payload: payload,
                                    CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                    ClientId: dData.sessionId}).then(data => {
                    if (data[0]){
                        setRead(false);
                        setCount(0);
                        setResGroupIdList([]);
                        formSuccess("Group updated.", "editSubmit", "loadEditSubmit", "cancelEditBtn");
                    }
                    else{
                        formFail(`Error during save, error code: ${data[1]}`, "editSubmit", "loadEditSubmit");
                    }
                });
            }else{
                toast.info("No data changed.");
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deletePerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (deleteRights){
            payload = [];
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent?.length; i++){
                payload.push({resident_group_id: parseInt(dContent[i][0])});
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "resident_group_delete", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setRead(false);
                    formSuccess("Groups have been deleted.", submitBtn, loadBtn, closeId);
                    setCount(0);
                    setResGroupIdList([]);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteBtn"]);
                }
                else{
                    formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    const tableHeaders = <TableHeaders checkbox={deleteRights} headerData={headerData} checkAll={() => checkAll(ppRules.start, ppRules.end, resGroupIdList, setResGroupIdList)}
                                       writeAccess={editRights} sortOrder={sorter.sortOrder} modal_name={"Edit"} originData={dataOrigin} headerFiltersOn={true}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} modal={editRights} checkboxlist={resGroupIdList}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteBtn"])}
                                       headerFilters={headerFilters} setHeaderFilters={setHeaderFilters} setPage={setPage} />;

    const resTableHead = <TableHeaders checkbox={true} headerData={headerData2} checkboxlist={resIdList}
                                         checkAll={() => checkAll(0, resDataCnt ? resDataCnt : 0, resIdList, setResIdList, "uCheckHead2", "uCheckGroup")}
                                         writeAccess={editRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead2"}
                                         sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2} originData={resData}
                                         headerFilters={headerResFilters} setHeaderFilters={setHeaderResFilters} headerFiltersOn={true} setPage={setPage}
                                         actionAppearance={() => {}} />

    const resAddTableHead = <TableHeaders checkbox={true} headerData={headerData2} checkboxlist={resIdList}
                                          checkAll={() => checkAll(0, resDataCnt ? resDataCnt : 0, resIdList, setResIdList, "uCheckHead3", "uCheckGroup")}
                                          writeAccess={addRights} sortOrder={sorter2.sortOrder} checkboxHeaderId={"uCheckHead3"}
                                          sortColumn={sorter2.sortColumn} sorter={sorter2} setSorter={setSorter2} originData={resData}
                                          headerFilters={headerResFilters} setHeaderFilters={setHeaderResFilters} headerFiltersOn={true} setPage={setPage}
                                          actionAppearance={() => {}} />

    const contentHeader = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                {deleteRights
                    ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                     id={"deleteBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                     onClick={() => bulkDeleteModal(ppRules.start, ppRules.end, activeData,
                                         "resident_group_name", ["resident_group_id", ""], "resident_group_name", setDContent)} />
                    :   <></>
                }
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"}
                            style={{height: "42px"}} icon={true} iconClass={"fe fe-search"} />
                </div>
                {csvButton}
                {addRights && resLoaded && catLoaded
                    ?   <Button text={"New Group"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                 icon={true} iconClass={"fe fe-plus me-2"}
                                 onClick={() => {
                                     setResLinkClose("cancelAddBtn");
                                     setSearch2("");
                                     setResIdList([]);
                                     setHeaderResFilters([]);
                                     document.getElementById("uCheckHead3").checked = false;
                                     setStoredIndex(undefined);
                                     showModal("addmodal");
                                     formCheck("addForm", "addSubmit");}} />
                    :   <></>
                }
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)} pageAction={() => {
                                setOriginLoaded(false);
                                setCatLoaded(false);
                                setPageLoaded(false);
                                setResLoaded(false);
            }}/>
        </div>
    );

    const footer = (
        <div>
            <Pagination>
                <PaginationItems setPage={setPage} page={page} beginDot={ppRules.beginDot}
                                 endDot={ppRules.endDot} pageMin={ppRules.pageMin} pageMax={ppRules.pageMax}
                                 max={ppRules.max}/>
            </Pagination>
            <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Community"} Title={"Residents"} content={contentHeader} />
                <div className={"container-fluid"}>
                    <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                        <li className={"nav-item"}>
                            <Link to={"/community/residents"}>
                                <Button text={"Residents"} class={loadState === "individuals" ? "nav-link active" : "nav-link"}
                                    onClick={() => setLoadState("individuals")} />
                            </Link>
                        </li>
                        <li className={"nav-item"}>
                            <Link to={"/community/residents/groups"}>
                                <Button text={"Resident Groups"} class={loadState === "groups" ? "nav-link active" : "nav-link"}
                                    onClick={() => setLoadState("groups")} />
                            </Link>
                        </li>
                    </ul>
                    {!pageLoaded
                        ?   skeleton
                        :   <table className={"table table-sm table-white table-hover"}>
                                <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {tableHeaders}
                                </thead>
                                <tbody id={"tBody"}>
                                    {tableRows}
                                </tbody>
                            </table>
                    }
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <Footer center={footer} />
            </div>
            <div className={"modal fade"} id={"addmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Add Group</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"addForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"category"} required={true}>
                                        <option value={""}></option>
                                        {groupCatDd}
                                    </select>
                                    <label htmlFor={"category"}>Group Category</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"groupname"}
                                           onKeyUp={() => formCheck("addForm", "addSubmit")}
                                           required={true} pattern={"[a-zA-Z0-9 _\\-]{0,100}"}/>
                                    <label htmlFor={"groupname"}>Group Name</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a valid group name.
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"description"}
                                           onKeyUp={() => formCheck("addForm", "addSubmit")}
                                           pattern={"[ -~]+"}/>
                                    <label htmlFor={"description"}>Description</label>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Residents</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {resAddTableHead}
                                            </thead>
                                            <tbody>
                                                {resTableRows}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelAddBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true} spinner={true}
                                        text={"Loading"} id={"loadAddSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"} onClick={() => formAddSubmit()} id={"addSubmit"}>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Edit Group</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                        </div>
                        <form id={"editForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <input type={"hidden"} id={"groupIdE"} />
                                <div className={"form-floating mb-3"}>
                                    <select className={"form-select"} id={"categoryE"} required={true}>
                                        <option value={""}></option>
                                        {groupCatDd}
                                    </select>
                                    <label htmlFor={"categoryE"}>Group Category</label>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"groupNameE"}
                                           onKeyUp={() => formCheck("editForm", "editSubmit")}
                                           required={true} pattern={"[a-zA-Z0-9 _\\-]{0,100}"}/>
                                    <label htmlFor={"groupNameE"}>Group Name</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter a group name!
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"descriptionE"}
                                           onKeyUp={() => formCheck("editForm", "editSubmit")}
                                           pattern={"[ -~]+"}/>
                                    <label htmlFor={"descriptionE"}>Description</label>
                                </div>
                                <hr />
                                <div className={"mt-1"}>
                                    <h3>Residents</h3>
                                    <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                        <input type={"search"} id={"search2E"} className={"form-control search-input"}
                                               value={search2}
                                               onChange={(e) => setSearch2(e.target.value)} />
                                        <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                    </div>
                                    <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {resTableHead}
                                            </thead>
                                            <tbody>
                                                {resTableRows}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                <div>
                                    {deleteRights
                                        ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger me-3"}
                                                     id={"deleteSingleBtn"} icon={true}
                                                     iconClass={"fe fe-trash-2 me-2"}/>
                                        :   <></>
                                    }
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true} text={"Loading"} id={"loadEditSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} onClick={() => formEditSubmit()} id={"editSubmit"}>Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <input className={"d-none"} type={"hidden"} id={"lastIndex"} />
            <SingleDeleteModal deletePerform={() => deletePerform("deleteSubmit", "loadDeleteSubmit",
                                                                "confirmClose", ppRules.start, ppRules.end)} header={"Delete Group"}/>
            <BulkDeleteModal deletePerform={() => deletePerform("bulkDeleteSubmit", "loadBulkDeleteSubmit",
                                                                "bulkConfirmClose", ppRules.start, ppRules.end)}
                             start={ppRules.start} end={ppRules.end} header={"Delete Groups"} />
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                          setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)}
                          setPage={(sudocode) => setPage(sudocode)}/>
            <input type={"hidden"} id={"uContent"}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default ResidentGroups;